<template>
  <article class="bg-white border border-gray-200 p-6 hover:bg-gray-25">
    <!-- Partner Name -->
    <h3 class="text-lg font-semibold mb-3">
      <a
        :href="partnerUrl"
        class="text-blue-600 hover:text-blue-800 hover:underline"
      >
        {{ partner.partner.name }}
      </a>
    </h3>

    <!-- Services -->
    <div v-if="partner.services.length > 0" class="mb-3">
      <h4 class="text-sm font-semibold text-gray-900 mb-2">CERT/CC Product Suite Products:</h4>
      <ul class="space-y-1">
        <li
          v-for="service in partner.services"
          :key="service.id"
          class="text-sm text-gray-700"
        >
          {{ service.SERVICE_DISPLAY }}
        </li>
      </ul>
    </div>


    <!-- Sponsored Professionals -->
    <div v-if="partner.people && partner.people.length > 0" class="mb-3">
      <h4 class="text-sm font-semibold text-gray-900 mb-2">Partner Sponsored Professionals:</h4>

      <div
        v-for="group in groupedPeople"
        :key="group.role"
        class="mb-2 last:mb-0"
      >
        <h5 class="text-sm font-medium text-gray-800 mb-1">{{ group.role }}</h5>
        <ul class="ml-4 space-y-1">
          <li
            v-for="person in group.people"
            :key="person.id"
            class="text-sm text-gray-700"
          >
            {{ person.first_name }} {{ person.last_name }}
            <a
              v-if="person.email"
              :href="`mailto:${person.email}`"
              class="text-blue-600 hover:text-blue-800 hover:underline ml-1"
            >
              ({{ person.email }})
            </a>
          </li>
        </ul>
      </div>
    </div>

    <!-- Email -->
    <div v-if="partner.partner.email" class="text-sm text-gray-600">
      <span class="font-semibold">Contact:</span>
      <a
        :href="`mailto:${partner.partner.email}`"
        class="text-blue-600 hover:text-blue-800 hover:underline ml-1"
      >
        {{ partner.partner.email }}
      </a>
    </div>
  </article>
</template>

<script setup lang="ts">
import { computed } from 'vue'

interface Person {
  id: number
  first_name: string
  last_name: string
  email?: string
  role: string
}

interface Partner {
  partner: {
    name: string
    id: number
    entry: { id: number; title: string; slug: string; url?: string }
    email: string | null
  }
  suites: Array<{ suite_name: string; suite_id: number }>
  services: Array<{ SERVICE_DISPLAY: string; id: number }>
  people: Person[]
}

const props = defineProps<{ partner: Partner }>()

const partnerUrl = props.partner.partner.entry?.url || '#'

const groupedPeople = computed(() => {
  const groups = new Map<string, Person[]>()

  props.partner.people?.forEach(person => {
    const role = person.role || 'Other'
    if (!groups.has(role)) {
      groups.set(role, [])
    }
    groups.get(role)?.push(person)
  })

  return Array.from(groups.entries()).map(([role, people]) => ({
    role,
    people
  }))
})
</script>
